<fieldset>
  @if (label) {
    <label [raskRequired]="required">
      {{label}}
      @if (infoText) {
        <rask-info>{{infoText}}.</rask-info>
      }
    </label>
  }
  @if(useItemIcons) {
        <i [ngClass]="imgFormatter(inputValue)" class="image-Input"></i>
  }
  <input #instance type="text" id="{{aid}}" placeholder="{{placeholder}}" [(ngModel)]="inputValue" [ngModelOptions]="{standalone: true}" (blur)="onBlur()"
    (focus)="onFocus();focus$.next($any($event.target).value)" (selectItem)="onSelect($event)"
    [ngbTypeahead]="searchHandler" [placement]="listPlacement" [resultFormatter]="viewFormatter" [resultTemplate]="rt"
    [ngClass]="{'input-format-img': useItemIcons}" [inputFormatter]="viewSelectedFormatter" [disabled]="disabled" [container]="portalToBody ? 'body' : null" (change)="onInputChange($event)" popupClass="rask-selector-typeahead {{popupClass}}"/>

    <i class="caret fal fa-angle-down" (click)="invokeClick()" [hidden]="value !== undefined && isFocused"
    [ngClass]="{'open': isFocused}"></i>
    <i class="selector-remove" (mousedown)="delete()"
    [ngClass]="{'enabled': inputValue !== undefined}" [hidden]="!canDelete || !isFocused"></i>
    <i [raskBusy]="busyIdentity"></i>

    <ng-template disabled #rt let-r="result" let-t="term">
      @if (r && r.header) {
        <ng-content select="[header]"></ng-content>
      }
      @if (groupBy && r && !r.header) {
        <h4>{{r.key}}</h4>
        @for (value of r.values; track value) {
          <ngb-highlight (click)="onGroupSelect($event, value);"
            [ngClass]="{'disabled': itemDisabled(value)}" [result]="viewFormatter(value)" [term]="t">
          </ngb-highlight>
        }
        <br>
        }
        @if (!groupBy && !r.header) {
            @if(useItemIcons) {
            <div class="item-image">
                <i [ngClass]="imgFormatter(r)"></i>
                <ngb-highlight [ngClass]="{'disabled': itemDisabled(r)}" [result]="viewFormatter(r)" [term]="t">
                </ngb-highlight>
            </div>
            }
            @else {
                <ngb-highlight [ngClass]="{'disabled': itemDisabled(r)}" [result]="viewFormatter(r)" [term]="t">
                </ngb-highlight>
            }
        }
      </ng-template>

      @if (rule) {
        <rask-validation-message [hidden]="isPopupOpen" [rule]="rule"></rask-validation-message>
      }
    </fieldset>